const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the presentation slide  component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Resource} Analyze injected to gain access to Analyze resource
 */
app.directive('presentationSlide', [function () {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        slidetype: "=",
        slideposition: "=",
        slidedata: "=",
        slideproperties: "=",
        slideactive: "=",
        islast: "=",
        exit: "&"
      },
      template: require('../../templates/directives/presentation-slide.html'),
      controller: ['$scope', function ($scope) {
          
          var self = this;
          self.date = new Date();

          self.isTouch = ('ontouchstart' in document.documentElement) ? 1 : 0;

          self.image = function () {
            
            if ($scope.slidetype === 'image') {
              if ($scope.slidedata) {
                return $scope.slidedata.replace('http://', '//');
              }
              return '//placehold.it/800x550';
            }

          };

          self.changeslide = function(direction){
            $scope.$emit('changeslide', direction);
          };

          self.exitPresentation = function() {
            $scope.exit();
          };

        }],
      controllerAs: 'slide'
    };
  }]);
